import { ChangeEventHandler } from 'react'
import { InputAdornment, ListSubheader, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

interface IProps {
  setSearch: (search: string) => void
  searchText: string
}

export const SearchInput = ({ setSearch, searchText }: IProps) => {
  const handleSearchChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearch(e.target.value)
  }

  return (
    <ListSubheader>
      <TextField
        size="small"
        autoFocus
        placeholder="Type to search..."
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        value={searchText}
        onChange={handleSearchChange}
        onKeyDown={(e) => {
          if (e.key !== 'Escape') {
            e.stopPropagation()
          }
        }}
      />
    </ListSubheader>
  )
}
